<template>
  <div v-if="show" class="alm-overlay">
    <div class="alm-box">
      <div class="alm-icon" :class="status === 'success' ? 'alm-icon-success' : 'alm-icon-error'">
        <fa-icon :icon="status === 'success' ? ['fas', 'check-circle'] : ['fas', 'exclamation-circle']" />
      </div>
      <h5 class="alm-title">{{ status === 'success' ? 'Success' : 'Error' }}</h5>
      <p class="alm-msg">{{ message }}</p>
      <button class="alm-btn" @click="$emit('close')">OK</button>
    </div>
  </div>
</template>

<script>
import bodyScrollLockMixin from '@/mixins/bodyScrollLockMixin'

export default {
  name: 'AlertModal',
  mixins: [bodyScrollLockMixin],
  props: {
    show: { type: Boolean, default: false },
    message: { type: String, default: '' },
    status: { type: String, default: 'success' }
  }
}
</script>
